module.exports = __webpack_public_path__ + "img/app-icon.9289922.png";